import { render, staticRenderFns } from "./barCodeReader.vue?vue&type=template&id=61fe7511&"
import script from "./barCodeReader.vue?vue&type=script&lang=js&"
export * from "./barCodeReader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports